import * as React from 'react';
export const capchaseSvg = React.forwardRef(function capchaseSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#323231',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M6.2 9.172c0 .822.45 1.581 1.18 1.992L15.979 16v-5.5l9.778 5.5v-4.172a2.29 2.29 0 0 0-1.181-1.992L15.978 5v5.5L6.2 5v4.172ZM25.756 16l-9.778 5.5V16l-8.597 4.836a2.29 2.29 0 0 0-1.18 1.992V27l9.777-5.5V27l8.597-4.836a2.29 2.29 0 0 0 1.18-1.992V16Z',
      fill: '#FDFBF9',
    }),
  );
});
capchaseSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var capchase = {
  category: 'brand',
  colorable: false,
  name: 'capchase',
  svg: capchaseSvg,
};
